import { Skeleton } from "@/components/ui/skeleton";
import { Loader2 } from "lucide-react";

interface AuthLoadingSkeletonProps {
  message?: string;
}

export function AuthLoadingSkeleton({ message = "Loading..." }: AuthLoadingSkeletonProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background charcoal-pro">
      <div className="text-center space-y-4">
        <div className="relative">
          <Skeleton className="h-16 w-16 rounded-full mx-auto" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary/50" />
          </div>
        </div>
        <div className="space-y-2">
          <p className="text-muted-foreground text-sm animate-pulse">{message}</p>
          <Skeleton className="h-1 w-32 mx-auto rounded-full" />
        </div>
      </div>
    </div>
  );
}
